export default "__VITE_ASSET__CCBHqPGG__"